const C = 'PREVIEW_RECEIVABLE_INVOICE_LIST_HISTORY';

export default {
    CHANGE_INVOICE_DETAIL: `${C}_CHANGE_INVOICE_DETAIL`
}